import { showConfirmModal } from '@components/ConfirmModal';
import { $curSandTable } from '@stores/dataStores';
import {
  $editingImageMarker,
  $editingImageMarkerApi,
  $editingMapMarker,
  $editingMapMarkerApi,
} from '@stores/editingMarkerStores';
import {
  $stImageSettingPanelApi,
  $stMapSettingPanelApi,
} from '@stores/sandTableStores';
import { SandTableType } from '@types';
import { createEvent } from 'effector';
import { delay } from 'pano-utils';
import { stEditorAmap } from '../STAMap';

export async function onMapMarkerClick(id: string) {
  $stMapSettingPanelApi.off();
  const sandTable = $curSandTable.getState();
  if (!sandTable || sandTable.type !== SandTableType.map) return;
  const marker = sandTable.markers.find((x) => x.id === id);
  if (!marker) return;
  const editing = $editingMapMarker.getState();
  const editingId = editing?.marker.id;
  if (editingId === id) return;
  if (editingId) {
    const oldData = sandTable.markers.find((x) => x.id === editingId)!;
    if (editing?.marker !== oldData || editing?.isNew) {
      const { confirmed } = await showConfirmModal({
        title: '有未保存的更改',
        content: '当前所有未经保存的改动将丢失, 是否继续?',
      });
      if (!confirmed) return;
    }
    stEditorAmap.removeMarker(editingId);
    if (oldData) {
      stEditorAmap.addMarker(oldData);
    }
    $editingMapMarkerApi.clear();
    await delay(100);
  }
  $editingMapMarkerApi.set({ marker });
}

export async function onImageMarkerClick(id: string) {
  $stImageSettingPanelApi.off();
  const sandTable = $curSandTable.getState();
  if (!sandTable) return;
  if (
    sandTable.type !== SandTableType.image &&
    sandTable.type !== SandTableType.matrix
  ) {
    return;
  }
  const marker = sandTable.markers.find((x) => x.id === id);
  if (!marker) return;
  const editing = $editingImageMarker.getState();
  const editingId = editing?.marker.id;
  if (editingId === id) return;
  if (editingId) {
    const oldData = sandTable.markers.find((x) => x.id === editingId)!;
    if (editing?.marker !== oldData || editing?.isNew) {
      const { confirmed } = await showConfirmModal({
        title: '有未保存的更改',
        content: '当前所有未经保存的改动将丢失, 是否继续?',
      });
      if (!confirmed) return;
    }
    $editingImageMarkerApi.clear();
    await delay(100);
  }
  $editingImageMarkerApi.set({ marker });
}

export const onMarkerClickGroupMode = createEvent<string>();
export const onMarkerClickBatchMode = createEvent<string>();
